import axios from 'axios'
import {SiteModel} from '../models'
import {ResponseObjectPaginated} from '../../../../central/model'
const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL

export function getSitesService(dto: SiteModel, page: number) {
  return axios.post<ResponseObjectPaginated<SiteModel[]>>(`${BASEURL}/site/getAll/${page}`, dto)
}
